import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import relativeTime from 'dayjs/plugin/relativeTime'
import updateLocale from 'dayjs/plugin/updateLocale'
import { locale } from '../constant'

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(relativeTime)
dayjs.extend(updateLocale)

if (locale === 'zh_CN') {
  dayjs.updateLocale('en', {
    relativeTime: {
      future: '%s内',
      past: '%s前',
      s: '几秒',
      ss: '%d秒',
      m: '1分钟',
      mm: '%d分钟',
      h: '1小时',
      hh: '%d小时',
      d: '1天',
      dd: '%d天',
      M: '1个月',
      MM: '%d个月',
      y: '1年',
      yy: '%d年',
      w: '1周',
      ww: '%d周'
    }
  })
}

const formatDate = (date, formatStr, forceFormat = false) => {
  let mFormat = ''
  if (formatStr) {
    let [, b] = formatStr.split(' ')
    mFormat = !b ? '' : ` ${b}`
  }
  let defaultFormat = locale === 'zh_CN' ? 'YYYY-MM-DD' : 'MM/DD/YYYY'
  let tz = locale === 'zh_CN' ? 'Asia/Shanghai' : 'America/Chicago'
  return dayjs(date)
    .tz(tz)
    .format(forceFormat ? formatStr : `${defaultFormat}${mFormat}`)
}

const formatDateFromNow = (date) => {
  let tz = locale === 'zh_CN' ? 'Asia/Shanghai' : 'America/Chicago'
  return dayjs(date).tz(tz).fromNow()
}

// get local time
export function getLocalTime(format = 'YYYY-MM-DD HH:mm:ss') {
  return dayjs().format(format)
}

const dateDiff = (date, type = 'days') => {
  return dayjs().diff(dayjs(date), type)
}

const isValidDate = (date) => {
  return dayjs(date).isValid()
}

export { formatDate, formatDateFromNow, dateDiff, isValidDate }
